import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { Container, Label, Input, FormGroup, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loading } from "../../share/loading";
import { FaSistrix } from "react-icons/fa";
import "../../share/form.css";
import CreateTableComponent from "../../share/CreateTableComponent";
import DocumentCheckListReadOnly from "./DocumentCheckListReadOnly";
import DocumentChecklist from "./DocumentCheckList";

export function SupportAdminCheckComponent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"));
  let supportId = searchParams.get("req");

  const [listTestPerson, setListTestPerson] = useState([]);
  const [modalListTestPerson, setModalListTestPerson] = useState(false);
  const ToggleModalListTestPerson = () => setModalListTestPerson(!modalListTestPerson);
  const [selectDocs, setSelectDocs] = useState([]);
  // console.log("selectDocs", selectDocs);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  // console.log("data", data);
  // console.log("data", data);

  useEffect(() => {
    getListTestPersonAnnounce4();
    getCheckSupport();
    if (user.roldId == 4) {
      getDocumentList()
    }
  }, []);


  const getDocumentList = async () => {
    setLoading(true);
    let postData = new FormData();
    postData.append("supportId", Number(supportId));
    try {
      let res = await fetch("/api/Support/getDocumentList", {
        method: "POST",
        body: postData,
      });
      const json = await res.json();
      setDocumentList(json.dataenum || []);
    } catch (e) {
      console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  async function getCheckSupport() {
    setLoading(true);
    let postData = new FormData();
    postData.append("supportId", supportId);
    try {
      let res = await fetch("/api/Support/detailsupporthelp", {
        method: "POST",
        body: postData,
      });
      const json = await res.json();
      setData(json.dataenum || []);
    } catch (e) {
      console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  async function getListTestPersonAnnounce4() {
    setLoading(true);
    let postData = new FormData();
    postData.append("supportId", supportId);
    try {
      let res = await fetch("/api/Support/getListTestPersonAnnounce4", {
        method: "POST",
        body: postData,
      });
      const json = await res.json();
      setListTestPerson(json.dataenum || []);
    } catch (e) {
      console.log("err", e);
    } finally {
      setLoading(false);
    }
  }

  const COLUMNS = [
    { Header: "ลำดับ", accessor: (_row, i) => i + 1 },
    { Header: "ชื่อ-นามสกุล", accessor: "names" },
    { Header: "สาขาอาชีพ", accessor: "lawOccupationName" },
    { Header: "สาขา", accessor: "testOccupationName" },
  ];

  const ShowListTestPersonAnnounce4 = () => (
    <Modal
      isOpen={modalListTestPerson}
      toggle={ToggleModalListTestPerson}
      backdrop={"static"}
      keyboard={false}
      size="xl"
      className="modal-bordered"
      centered
    >
      <ModalHeader toggle={ToggleModalListTestPerson}>
        รายชื่อผู้ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ
      </ModalHeader>
      <ModalBody>
        <CreateTableComponent
          column={COLUMNS}
          dataInput={listTestPerson}
          showEntrie={true}
          showPage={true}
        />
      </ModalBody>
    </Modal>
  );

  const formInitialValues = {
    supportstatusId: "5",
    supportId: searchParams.get("req"),
    userApprove: user.fullName,
    Fsenttest: "",
    Freportcertificate26: "",
    Fcertificate26: "",
    Fdelivertest: "",
    Fwagerate: "",
    Fpaidfee: "",
    FAnno5NameTesting: "",
    FAnno5RateTesting: "",
    FAnno6SubsidyLast: "",
    FAnno6SubsidySystem: "",
    FAnno7SubsidyLast: "",
    FAnno7SubsidySystem: "",
    reason: "",
  };

  const validateSchema = Yup.object().shape({});

  const onSubmit = async (values) => {
    setLoading(true);
    let postData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      postData.append(key, value);
    });

    selectDocs.forEach((doc) => {
      postData.append("selectDocs", doc);

    })
    try {
      let res = await fetch("/api/Support/approveOrRejectsupportOfficer", {
        method: "POST",
        body: postData,
      });
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          text: "",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(`/supporting/`);
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "บันทึกข้อมูลไม่สำเร็จ",
          text: `เนื่องจาก ${resJson.message}`,
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        });
      }
    } catch (e) {
      console.log("err =>", e);
    } finally {
      setLoading(false);
    }
  };

  // ✅ ดึง supportTypeId จากข้อมูลที่โหลดมา (เช็คตามรูปแบบจริงของ API)
  const supportTypeId = data?.[0]?.supportTypeId ?? data?.[0]?.support_type_id ?? data?.[0]?.supportType ?? null;
  console.log("supportTypeId", supportTypeId);

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center">
      <p
        className="text-center py-2 text-white"
        style={{ backgroundColor: "#0A66C2", width: "100%", maxWidth: "960px" }}
      >
        ข้อมูลคำขอผู้ขอรับเงินช่วยเหลือหรืออุดหนุน
      </p>

      <div className="form-border">
        {!loading ? (
          <>
            {data.map((item, i) => (
              <div className="p-5" key={i}>
                <FormGroup className="d-flex align-items-center">
                  <span className="type-register me-3 w-50">เลขที่อ้างอิง</span>
                  <Input className="input-color rounded-pill  text-center" disabled value={item.supportId} />
                </FormGroup>
                <FormGroup className="d-flex align-items-center">
                  <span className="type-register me-3 w-50">วันที่ขอรับเงินช่วยเหลือหรืออุดหนุน</span>
                  <Input className="input-color rounded-pill  text-center" disabled value={item.createdate} />
                </FormGroup>
                <FormGroup className="d-flex align-items-center">
                  <span className="type-register me-3 w-50">ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</span>
                  <Input className="input-color rounded-pill  text-center" disabled value={item.supportName} />
                </FormGroup>
                <FormGroup className="d-flex align-items-center">
                  <span className="type-register me-3 w-50">จำนวนเงิน (บาท)</span>
                  <Input className="input-color rounded-pill  text-center" disabled value={item.amount} />
                </FormGroup>
                <div className="d-flex justify-content-center">
                  <button
                    className="btn-blue rounded-pill w-50 my-2"
                    onClick={() => { navigate(`/supporting/admin/check/detail?id=${searchParams.get("req")}&type=${data[0]?.supportTypeId}&dataVersion=${data[0]?.dataVersion}`); }}
                  >
                    ดูรายละเอียดคำขอรับเงินช่วยเหลือหรืออุดหนุนเพิ่มเติม
                    <FaSistrix className="mx-2 style-icon" />
                  </button>
                </div>
              </div>
            ))}
          </>
        ) : (
          <Loading />
        )}
      </div>

      {/* แบบฟอร์มแนบไฟล์เพิ่มเติมสำหรับเจ้าหน้าที่ */}
      <p
        className="text-center py-2 text-white mt-3"
        style={{ backgroundColor: "#0A66C2", width: "100%", maxWidth: "960px" }}
      >
        {user.roldId === "3" ? "สําหรับ เจ้าหน้าที่พิจารณา" : "เอกสารเพิ่มเติมของเจ้าหน้าที่สพร./สนพ."}
      </p>

      <div className="form-border">
        {user.roldId === "3" ? (
          <Formik
            initialValues={formInitialValues}
            validationSchema={validateSchema}
            onSubmit={onSubmit}
            enableReinitialize
          >
            {({ values, handleChange, handleBlur, setFieldValue, submitForm }) => {
              const confirmSupport = () => {
                Swal.fire({
                  icon: "warning",
                  title: "ยืนยันการทำรายการหรือไม่ ?",
                  text: "",
                  confirmButtonColor: "#0A66C2",
                  confirmButtonText: "ตกลง",
                  showCancelButton: true,
                  cancelButtonText: "ยกเลิก",
                  cancelButtonColor: "#ff0000",
                }).then((result) => {
                  if (result.isConfirmed) {
                    setFieldValue("supportstatusId", "5");
                    submitForm();
                  }
                });
              };

              const rejectSupport = () => {
                Swal.fire({
                  icon: "info",
                  title: "กรุณากรอกเหตุผล",
                  input: "text",
                  inputAttributes: { autocapitalize: "off" },
                  confirmButtonColor: "#0A66C2",
                  confirmButtonText: "ตกลง",
                  showCancelButton: true,
                  cancelButtonText: "ยกเลิก",
                  cancelButtonColor: "#ff0000",
                  preConfirm: async (reason) => {
                    setFieldValue("reason", reason);
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    setFieldValue("supportstatusId", "17");
                    submitForm();
                  }
                });
              };

              const editSupport = () => {
                Swal.fire({
                  icon: "info",
                  title: "กรุณากรอกเหตุผล",
                  input: "text",
                  inputAttributes: { autocapitalize: "off" },
                  confirmButtonColor: "#0A66C2",
                  confirmButtonText: "ตกลง",
                  showCancelButton: true,
                  cancelButtonText: "ยกเลิก",
                  cancelButtonColor: "#ff0000",
                  preConfirm: async (reason) => {
                    setFieldValue("reason", reason);
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    setFieldValue("supportstatusId", "4");
                    submitForm();
                  }
                });
              };

              return (
                <Form autoComplete="off">
                  {/* ✅ ส่ง supportTypeId ให้ DocumentChecklist */}
                  <DocumentChecklist
                    supportTypeId={supportTypeId}
                    setSelectDocs={setSelectDocs}
                    onConfirm={(checkedMap) => {
                      // จะเก็บลงค่าฟอร์ม / ส่งต่อ backend ก็ได้
                      console.log("Checklist:", checkedMap, "supportTypeId:", supportTypeId);
                    }}
                  />

                  {/* เงื่อนไขส่วนอื่นๆ ที่ผูกกับ supportAnnounce เดิม */}
                  {data[0]?.supportAnnounce == 4 ? (
                    <FormGroup className="p-5">
                      <div className="d-flex align-items-center justify-content-between">
                        <Label className="w-75">
                          รายชื่อผู้ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติของศูนย์ทดสอบฯ
                          ในระบบรายงานผลผู้ผ่านการทดสอบ
                        </Label>
                        <FaSistrix className="mx-2 style-icon" onClick={ToggleModalListTestPerson} />
                      </div>
                    </FormGroup>
                  ) : null}

                  {/* {data[0]?.supportAnnounce == 5 ? (
                    <FormGroup className="p-5">
                      <div className="d-flex align-items-center justify-content-between">
                        <Label>
                          หนังสือกรมพัฒนาฝีมือแรงงาน เรื่อง
                          ขอส่งผู้เข้ารับการทดสอบมาตรฐานฝีมือแรงงาน(แนบไฟล์)
                        </Label>
                        <Input
                          name="Fsenttest"
                          type="file"
                          className="mt-2 w-50 rounded-pill text-center input-color"
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            if (e.target && e.target.files[0]) {
                              setFieldValue(`Fsenttest`, e.target.files[0]);
                            }
                          }}
                        />
                      </div>
                    </FormGroup>
                  ) : null} */}

                  {/* {data[0]?.supportAnnounce == 8 ? (
                    <div className="d-flex align-items-center justify-content-between p-4">
                      <Label className="w-75">
                        รายงานผลการทดสอบมาตรฐานฝีมือแรงงาน ตามมาตรา 26 (แบบ รมฐ.4) (แนบไฟล์)
                      </Label>
                      <Input
                        name="Freportcertificate26"
                        type="file"
                        className="mt-2 w-25 rounded-pill text-center input-color w-25"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          if (e.target && e.target.files[0]) {
                            setFieldValue(`Freportcertificate26`, e.target.files[0]);
                          }
                        }}
                      />
                    </div>
                  ) : null} */}

                  {data[0]?.supportAnnounce == 9 ? (
                    <FormGroup className="p-5">
                      <div className="d-flex align-items-center justify-content-between">
                        <Label className="w-75">
                          ประกาศคณะกรรมการจ้างเรื่องอัตราค่าจ้างมาตรฐานฝีมือแรงงาน (แบบไฟล์)
                        </Label>
                        <Input
                          name="Fwagerate"
                          type="file"
                          className="mt-2 w-25 rounded-pill text-center input-color w-25"
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            if (e.target && e.target.files[0]) {
                              setFieldValue(`Fwagerate`, e.target.files[0]);
                            }
                          }}
                        />
                      </div>
                    </FormGroup>
                  ) : null}

                  {user.roldId === "3" ? (
                    <div className="d-flex justify-content-evenly pt-4 w-100">
                      <div className="d-flex justify-content-evenly pt-4 w-100">
                        <button type="button" className="btn-green w-25" onClick={confirmSupport}>
                          เห็นควรอนุมัติ
                        </button>
                        <button type="button" onClick={editSupport} className="btn-warning border rounded-pill text-white w-25">
                          แจ้งแก้ไข
                        </button>
                        <button type="button" onClick={rejectSupport} className="btn-red w-25">
                          ไม่เห็นควรอนุมัติ
                        </button>
                      </div>
                    </div>
                  ) : null}
                </Form>
              );
            }}
          </Formik>
        ) : null}

        {user.roldId === "4" && documentList.length > 0 && (
          <DocumentCheckListReadOnly
            supportTypeId={supportTypeId}
            docs={documentList} // ใช้เอกสารจาก API สำหรับเจ้าหน้าที่ตรวจสอบ
          />
        )}

        <div className="d-flex align-items-center justify-content-center w-100 mt-3 mb-3">
          <button
            onClick={() => navigate(`/supporting/`)}
            className="btn-blue p-2 w-50"
          >
            ย้อนกลับ
          </button>
        </div>
      </div>

      <ShowListTestPersonAnnounce4 />
    </Container>
  );
}
